import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch} from 'react-redux';
import { useLocation } from "react-router-dom";
import { getSeoContents, updateSeoContent } from './seoContentSlice';
import { Container, Toast } from 'react-bootstrap';
import MetaFormCard from '../../components/metaContents/MetaFormCard';
import { useLoader } from '../../context/LoaderContext';

const PAGE_CONFIGS = [
  { slug: 'home-page', title: 'Home Page Meta Tags' },
  { slug: 'about-us', title: 'About Us Page Meta Tags' },
  { slug: 'contact-us', title: 'Contact Us Page Meta Tags' },
  { slug: 'gallery-page', title: 'Gallery Page Meta Tags' },
  { slug: 'blog-page', title: 'Blog Page Meta Tags' },
  { slug: 'target-region', title: 'Target Region Page Meta Tags' },
  { slug: 'terms-and-conditions', title: 'Terms And Conditions Page Meta Tags' },
  { slug: 'privacy-policy', title: 'Privacy Policy Page Meta Tags' },
];

const SettingList = () => {
  const dispatch = useDispatch();
  const { setLoading } = useLoader();

  const location = useLocation();
      const pathSegments = location.pathname.split("/").filter(Boolean);
      const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
        ? pathSegments[1] 
        : null;

  const [seoDataMap, setSeoDataMap] = useState({});
  const [editingSection, setEditingSection] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarVariant, setSnackbarVariant] = useState('success');

  const fetchSeoContent = useCallback(async (slug) => {
    try {
      const payload = { 
        slug,
        organization_id: selected_organization_id
      };
      const res = await dispatch(getSeoContents({ payload }));
      if (res.payload) {
        setSeoDataMap(prev => ({ ...prev, [slug]: res.payload.data }));
      }
    } catch (error) {
      console.error(`Error loading SEO data for ${slug}:`, error);
    }
  }, [dispatch, selected_organization_id]);
  
  useEffect(() => {
    setLoading(true);
    Promise.all(PAGE_CONFIGS.map(cfg => fetchSeoContent(cfg.slug))).finally(() => {
      setLoading(false);
    });
  }, [fetchSeoContent, setLoading]);


  const saveMetaContents = async (values, { setErrors, setSubmitting }) => {
    try {
      setIsSubmitting(true);
      setSubmitting(true);
      const valuesData = {
        organization_id: selected_organization_id,
        ...values
      }
      const res = await dispatch(updateSeoContent(valuesData));

      if(res.payload.success) {
        setSnackbarMessage(res.payload.message || 'Meta contents updated');
        setSnackbarVariant('success');
        setEditingSection(null);
        fetchSeoContent(values.slug);
      } else {
        setErrors(res.payload.data || {});
        setSnackbarMessage(res.payload.message || 'Failed to update');
        setSnackbarVariant('danger');
      }
    } catch (error) {
      setSnackbarMessage('Failed to update Meta contents');
      setSnackbarVariant('danger');
    } finally {
      setShowSnackbar(true);
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: 'white' }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Container fluid className="px-0">
        {PAGE_CONFIGS.map(({ slug, title }) => (
          <MetaFormCard
            key={slug}
            title={title}
            slug={slug}
            seoData={seoDataMap[slug]}
            editingSection={editingSection}
            setEditingSection={setEditingSection}
            isSubmitting={isSubmitting}
            onSubmit={saveMetaContents}
            onCancel={() => setEditingSection(null)}
          />
        ))}
      </Container>
    </>
  );
};

export default SettingList;
